import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import ExternalPromotionToast from 'bento-ordering/promotions/components/ExternalPromotionToast';
import useExternalPromotion from 'bento-ordering/promotions/hooks/useExternalPromotion';
import { MENU_BASE } from 'bento-ordering/menus/constants/paths';

function BentoOrderingExternalPromotionToast() {
  const { path } = useRouteMatch();
  const { externallyLinkedPromotion, error } = useExternalPromotion();

  if (!externallyLinkedPromotion || path !== MENU_BASE) {
    return null;
  }

  const getToastMessage = () => {
    if (error) {
      return 'Sorry, promotion has expired';
    } else if (externallyLinkedPromotion?.unlocked) {
      return 'Promotion unlocked!';
    } else if (externallyLinkedPromotion) {
      return 'Promotion available!';
    }
  };
  return <ExternalPromotionToast toastMessage={getToastMessage()} />;
}

export default BentoOrderingExternalPromotionToast;
